export default "__VITE_ASSET__mACC$mWQ__"